/* import __COLOCATED_TEMPLATE__ from './conversation-rating-remark-added.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const ConversationRatingRemarkAdded = templateOnlyComponent<Signature>();
export default ConversationRatingRemarkAdded;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ConversationRatingRemarkAdded': typeof ConversationRatingRemarkAdded;
    'inbox2/conversation-stream/event-parts/conversation-rating-remark-added': typeof ConversationRatingRemarkAdded;
  }
}
